import { Typography } from '@mui/material';
import { useLayoutEffect } from 'react';
import Grid from '@mui/material/Grid';
import styled from 'styled-components';

import { LOGGED_IN_USER } from '../../constants/common';
import Error404Art from '../../images/error404art.svg';
import getCookie from '../../utils/cookie';
import useAuth from '../../context/AuthContext';
import useLoader from '../../context/LoaderContext';

const StyledImage = styled.img`
  max-width: 500px;
  width: 100%;
`;

const CustomTypo = styled(Typography)`
  &.MuiTypography-root {
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 32px;
    text-align: center;
    color: rgba(0, 0, 0, 0.56);
    max-width: 491px;
  }
`;

const Error404 = () => {
  // init
  const { setIsLoading } = useLoader();
  const { authUser } = useAuth();

  useLayoutEffect(() => {
    setIsLoading(false);
  }, [authUser]);

  return (
    <div className="error-page">
      <Grid container>
        <Grid
          item
          style={{ marging: '0 auto' }}
          xs={12}
          sm={12}
          md={12}
          lg={12}
          xl={12}
          align="center"
        >
          <StyledImage src={Error404Art} alt="noprojectart" draggable="false" />
        </Grid>
        <Grid
          item
          style={{ marging: '0 auto' }}
          xs={12}
          sm={12}
          md={12}
          lg={12}
          xl={12}
          align="center"
        >
          <CustomTypo style={{ marging: '0 auto' }} component="span">
            This page doesn’t exist or was removed!
            {getCookie(LOGGED_IN_USER) ? (
              <CustomTypo sx={{ mx: 'auto' }}> We suggest you to try different page.</CustomTypo>
            ) : (
              <CustomTypo sx={{ mx: 'auto' }}>We suggest you to login.</CustomTypo>
            )}
          </CustomTypo>
        </Grid>
      </Grid>
    </div>
  );
};

export default Error404;
